import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  Label,
  Row,
  Col,
  Button,
} from "reactstrap";
import FileSaver from "file-saver";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { CalenderIcon } from "../Icon";
import { NewDownloadIcon, NewDownloadIconActive } from "../../assets/images";
import { DownloadClientDirectoryReportType } from "../../commonTypes/clientDirectoryTypes";
import { downloadClientDirectoryReportsApi } from "../../apis/clientDirectory";
import toast from "react-hot-toast";
import { Toaster } from "react-hot-toast";
type AppProps = {
  token: null | string;
};

const ClientDownloadReport = ({ token }: AppProps) => {
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const toggleShowDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleCancel = () => {
    setStartDate(null);
    setEndDate(null);
    setShowDropdown(!showDropdown);
  };

  const handleStartDate = (date: any) => {
    setStartDate(date);
    setEndDate(null);
  };

  const handleDownload = () => {
    setIsLoading(true);
    setShowDropdown(false);

    handlePrepareReportData();
  };

  const handlePrepareReportData = () => {
    let params: DownloadClientDirectoryReportType = {
      start_date: moment(startDate).format("DD-MM-YYYY"),
      end_date: moment(endDate).format("DD-MM-YYYY"),
      token,
    };

    if (params && token) {
      handleDownloadReport(params);
    }
  };

  const handleDownloadReport = (params: any) => {
    let reportName = `client_directory_Report${params?.start_date}-${params?.end_date}.xlsx`;

    downloadClientDirectoryReportsApi(params).then((response) => {
      setIsLoading(false);

      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);
      toast.success("Report Downloaded Successfully!", {
        duration: 3000,
      });
      setStartDate(null);
      setEndDate(null);
    });
  };

  return (
    <>
      <ButtonDropdown
        isOpen={showDropdown}
        toggle={toggleShowDropdown}
        className="download-report-btn"
        style={
          showDropdown
            ? {
                color: "#dd4433",
                backgroundColor: "#fff6f5",
              }
            : {}
        }
      >
        <OverlayTrigger
          placement="bottom"
          delay={{ show: 250, hide: 250 }}
          overlay={
            <Tooltip id="button-view-download-invoice">
              Download Reports
            </Tooltip>
          }
        >
          <DropdownToggle
            caret
            // color="secondary"
            outline
            style={
              showDropdown
                ? {
                    color: "#dd4433",
                    backgroundColor: "#fff6f5",
                  }
                : { border: "1px solid#bfcbe1" }
            }
          >
            {/* <DownloadIcon />  */}
            <img
              src={showDropdown ? NewDownloadIconActive : NewDownloadIcon}
              alt="download icon"
            />
          </DropdownToggle>
        </OverlayTrigger>
        <DropdownMenu right>
          <div className="download-dropdown p-3">
            <h4>Download Report</h4>

            <Row>
              <Col md={6} className="form-group">
                <div>Start Date </div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={startDate}
                        onChange={handleStartDate}
                        selectsStart
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="form-group">
                <div>End Date</div>
                <Row>
                  <Col md="12" className="download-report-picker">
                    <Label className="m-0 p-0">
                      <span className="calender-icon">
                        <CalenderIcon />
                      </span>
                      <DatePicker
                        dateFormat="dd-MM-yyyy"
                        selected={endDate}
                        onChange={(date: any) => setEndDate(date)}
                        selectsEnd
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        className="form-control"
                      />
                    </Label>
                  </Col>
                </Row>
              </Col>
              <Col md={12} className="text-right">
                <button
                  className="btn btn-outline-secondary mr-3"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={startDate && endDate ? false : true}
                >
                  Download
                </button>
              </Col>
            </Row>
          </div>
        </DropdownMenu>
      </ButtonDropdown>
      <Toaster />
    </>
  );
};

export default ClientDownloadReport;
